<template>
    <slot />
</template>

<script>
export default {
    name: 'LoginLayout'
}
</script>

<style lang="scss">
.form-signin {
  text-align: center;
}

</style>
